import React from 'react'
import { withTranslation } from 'react-i18next'
import './thanks-for-voting.scss'

const ThanksForVoting = ({ t }) => (
  <div className="yo-thanks-for-voting">{t('thanks-for-voting')}</div>
)

export default withTranslation(['NodeReview'])(ThanksForVoting)
